<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { mapGetters } from "vuex";
import draggable from 'vuedraggable';
import { menuItems as defaultMenuItems } from "./menu";


/**
 * Sidebar component
 */
export default {
  components: { draggable },
  
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      localMenuItems: [], 
      menuRef: null,
    };
  },
  computed:{
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["GeneralSettings"]),
  },
  created() {
    this.loadMenuOrder();
  },
  mounted: function () {
    this.reinitializeMenu();
    this.setActiveMenuItem();
  },
  watch: {
    $route: {
      deep: true,
       handler: function () {
        this.setActiveMenuItem();
      },
      immediate: true
    },
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size")
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
    MyUserPerm() {
      this.$nextTick(() => {
        this.reinitializeMenu();
      });
    }
  },

    methods: {
    onRoutechange() {
      setTimeout(() => {
        if(document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
        }
      }, 300);
    },
     loadMenuOrder() {
      const savedOrderJSON = localStorage.getItem('userMenuOrder');
      
      if (savedOrderJSON) {
        try {
          const parsedOrder = JSON.parse(savedOrderJSON);

          const getAllIds = (items) => items.flatMap(item => [item.id, ...(item.subItems ? getAllIds(item.subItems) : [])]);
          const allIds = getAllIds(parsedOrder);
          const uniqueIds = new Set(allIds);

          if (allIds.length !== uniqueIds.size) {
            throw new Error("Duplicate IDs detected in saved menu data. Resetting.");
          }

          const savedIds = new Set(parsedOrder.map(item => item.id));
          const newItems = defaultMenuItems.filter(item => !savedIds.has(item.id));
          this.localMenuItems = [...parsedOrder, ...newItems];

        } catch (e) {
          localStorage.removeItem('userMenuOrder'); // Clear corrupted data
          this.localMenuItems = JSON.parse(JSON.stringify(defaultMenuItems));
        }
      } else {
        this.localMenuItems = JSON.parse(JSON.stringify(defaultMenuItems));
      }
    },
    saveMenuOrder() {
      localStorage.setItem('userMenuOrder', JSON.stringify(this.localMenuItems));
    },
    onDragEnd() {
      this.saveMenuOrder();
    },

    resetMenuOrder() {
        localStorage.removeItem('userMenuOrder');
        location.reload();
    },

    showResetMenuModal(){
      this.$bvModal.show('reset-menu-modal');
    },

    reinitializeMenu() {
      if (this.menuRef) {
        this.menuRef.dispose();
      }
      this.$nextTick(() => {
        const menuElement = document.getElementById("side-menu");
        if (menuElement && menuElement.children.length > 0) {
          this.menuRef = new MetisMenu("#side-menu");
        }
      });
    },

    setActiveMenuItem() {
      this.$nextTick(() => {
        this.clearActiveStates();
        const currentPath = window.location.pathname;
        const links = document.querySelectorAll(".side-nav-link-ref");
        let matchingMenuItem = null;
        for (const link of links) {
          if (link.getAttribute('href') === currentPath) {
            matchingMenuItem = link;
            break;
          }
        }
        if (!matchingMenuItem) {
          for (const link of links) {
            const href = link.getAttribute('href');
            if (href && href !== '/' && currentPath.startsWith(href)) {
              matchingMenuItem = link;
              break;
            }
          }
        }
        if (matchingMenuItem) {
          this.activateMenuItem(matchingMenuItem);
        }
      });
    },
    clearActiveStates() {
      document.querySelectorAll('.mm-active, .mm-show, .active').forEach(element => {
        element.classList.remove('mm-active', 'mm-show', 'active');
      });
      document.querySelectorAll('a.active, a.router-link-active').forEach(link => {
        link.classList.remove('active', 'router-link-active');
      });
      document.querySelectorAll('ul.mm-show').forEach(ul => {
        ul.classList.remove('mm-show');
      });
    },
    activateMenuItem(menuItem) {
      menuItem.classList.add('active');
      let parent = menuItem.parentElement;
      while (parent && parent.id !== 'side-menu') {
        if (parent.tagName === 'LI') {
          parent.classList.add('mm-active');
        }
        const parentUl = parent.closest('ul.sub-menu');
        if (parentUl) {
          parentUl.classList.add('mm-show');
          const parentLi = parentUl.closest('li');
          if (parentLi) {
            parentLi.classList.add('mm-active');
            const parentAnchor = parentLi.querySelector('a');
            if (parentAnchor) parentAnchor.classList.add('active');
          }
        }
        parent = parent.parentElement;
      }
    },
    hasItems(item) {
      return item.subItems && item.subItems.length > 0;
    },
    hasPermission(item) {
      if (!item.perm) return true;
      return this.MyUserPerm && this.MyUserPerm[item.perm] == 1;
    },
    hasSettingPermission(item) {
      if (!item.set) return true;
      return this.GeneralSettings && this.GeneralSettings[item.set] == 1;
    },
    shouldShowMenuItem(item) {
      const actionPageCheck = !item.actionpage || (item.actionpage && this.BranchData && this.BranchData.BranchId != 0);
      return this.hasPermission(item) && this.hasSettingPermission(item) && actionPageCheck;
    },
    shouldRenderMenuItem(item) {
      if (!this.shouldShowMenuItem(item)) {
        return false;
      }
      if (item.isLayout) {
        return false;
      }
      if (this.hasItems(item)) {
        return item.subItems.some(child => this.shouldRenderMenuItem(child));
      }
      return !!item.link;
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div id="sidebar-menu">
    <draggable
      tag="ul"
      v-model="localMenuItems"
      class="metismenu list-unstyled"
      id="side-menu"
      handle=".drag-handle"
      @end="onDragEnd"
    >
      <template v-for="item in localMenuItems">
        <li v-if="shouldRenderMenuItem(item)" :key="item.id">
          
          <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent" :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
            <i class="bx bx-grid-vertical drag-handle"></i>
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
          </a>

          <router-link :to="item.link" v-if="!hasItems(item) && item.link" class="side-nav-link-ref">
            <i class="bx bx-grid-vertical drag-handle"></i>
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
          </router-link>

          <draggable v-if="hasItems(item)" tag="ul" class="sub-menu" aria-expanded="false" v-model="item.subItems" handle=".drag-handle-sub" @end="onDragEnd">
            <template v-for="subitem in item.subItems">
              <li v-if="shouldRenderMenuItem(subitem)" :key="subitem.id">
                
                <router-link :to="subitem.link" v-if="!hasItems(subitem) && subitem.link" class="side-nav-link-ref">
                  <i class="bx bx-grid-vertical drag-handle-sub"></i>
                  {{ $t(subitem.label) }}
                </router-link>

                <a v-if="hasItems(subitem)" class="has-arrow" href="javascript:void(0);">
                  <i class="bx bx-grid-vertical drag-handle-sub"></i>
                  {{ $t(subitem.label) }}
                </a>
                
                <draggable v-if="hasItems(subitem)" tag="ul" class="sub-menu mm-collapse" aria-expanded="true" v-model="subitem.subItems" handle=".drag-handle-sub-sub" @end="onDragEnd">
                  <template v-for="subSubitem in subitem.subItems">
                    <li v-if="shouldRenderMenuItem(subSubitem)" :key="subSubitem.id">
                      <router-link :to="subSubitem.link" v-if="subSubitem.link" class="side-nav-link-ref">
                       <i class="bx bx-grid-vertical drag-handle-sub-sub"></i>
                        {{ $t(subSubitem.label) }}
                      </router-link>
                    </li>
                  </template>
                </draggable>
              </li>
            </template>
          </draggable>
        </li>
      </template>
    </draggable>
  <!-- Left Sidebar End -->
  <div class="reset-menu-container">
      <button @click="showResetMenuModal" class="reset-menu-button">
        <i class="bx bx-reset"></i> Reset Menu Order
      </button>
    </div>

        <!-- modal reset memnu starts -->
    <b-modal
        header-bg-variant="info"
        header-text-variant="light"
        body-text-variant="info"
        footer-bg-variant="info"
        footer-text-variant="info"
        id="reset-menu-modal"
        hide-footer
    >
      <template #modal-title>Reset Menu Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            You are changing the menu order back to its default? Click Reset button to proceed.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('reset-menu-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-info"
            @click="resetMenuOrder('reset-menu-modal')"
        >
          <i class="bx bx-reset"></i> Reset
        </button>
      </div>
    </b-modal>
    <!-- modal reset memnu ends -->
  </div>

</template>

<style scoped>
.drag-handle,
.drag-handle-sub,
.drag-handle-sub-sub {
  cursor: move;
  color: #858d98;
  opacity: 0.5;
  margin-right: 8px;
  transition: opacity 0.2s;
}
.drag-handle:hover,
.drag-handle-sub:hover,
.drag-handle-sub-sub:hover {
  opacity: 1;
}
.drag-handle-sub {
  font-size: 12px;
  margin-right: 5px;
}
.drag-handle-sub-sub {
   font-size: 11px;
   margin-right: 4px;
}

.reset-menu-container {
  padding: 20px 15px;
  text-align: center;
  border-top: 1px solid #404854;
  margin-top: 10px;
}
.reset-menu-button {
  background-color: #4f5763;
  color: #a6b0cf;
  border: 1px solid #5d6674;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  font-size: 13.5px;
  transition: background-color 0.2s, color 0.2s;
}
.reset-menu-button:hover {
  background-color: #5d6674;
  color: #ffffff;
}
.reset-menu-button .bx {
  margin-right: 5px;
  vertical-align: middle;
}
</style>

